import { Elements } from "@stripe/react-stripe-js";

import { stripePromise } from "./stripe";

type StripeProviderProps = { children: React.ReactNode };

const StripeProvider = ({ children }: StripeProviderProps) => {
  return (
    // Keep params outside of the render function to avoid rerenders
    <Elements stripe={stripePromise}>{children}</Elements>
  );
};

export default StripeProvider;
